import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import {
  TabComponent,
  TabItemDirective,
  TabItemsDirective,
} from '@syncfusion/ej2-react-navigations';
import {
  ButtonPropsModel,
  DialogComponent,
} from '@syncfusion/ej2-react-popups';
import React, { Component } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import { BiColumns } from 'react-icons/bi';
import { BsColumns } from 'react-icons/bs';
import { RiMenu5Fill } from 'react-icons/ri';
import KanbanDesignService from '../../../services/Kanban/KanBanDesign';
import Message from '../../../utils/Message/Message';
import '../../Settings/KanBan/kanban.css';
import { all_information } from '../../../App';

interface IProps {}
interface IState {
  swimLineData: Array<any>;
  yPos: string;
  xPos: string;
  showMenu: boolean;
  hideDialog: boolean;
  isParent: boolean;
  hideEditDialog: boolean;
}
export default class SwimLine extends Component<IProps, IState> {
  private buttonsPopup: ButtonPropsModel[];
  private current_object: Array<any> = [];
  private buttonForEdit: ButtonPropsModel[];
  private headerName: string = '';
  private kanbanDesign: KanbanDesignService = new KanbanDesignService();

  constructor(prop: IProps) {
    super(prop);
    this.state = {
      swimLineData: [],
      showMenu: false,
      xPos: '0px',
      yPos: '0px',
      hideDialog: false,
      isParent: false,
      hideEditDialog: false,
    };
    this.buttonsPopup = [
      {
        click: () => {
          // this.saveColor();
        },
        buttonModel: {
          content: 'Accept',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialog: false });
        },
        buttonModel: {
          content: 'Cancel',
        },
      },
    ];
    this.buttonForEdit = [
      {
        click: () => {
          this.setHeaderName();
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideEditDialog: false });
        },
        buttonModel: {
          content: 'Cancel',
          isPrimary: false,
        },
      },
    ];
  }
  setHeaderName() {
    if (this.headerName === '') {
      Message.error('Header name couldnt be empty');
      return;
    }
    var theObject = {};
    var max_id = 0;
    for (var i = 0; i < this.state.swimLineData.length; i++) {
      var theSample = this.state.swimLineData[i];
      if (max_id < theSample.zIndex) {
        max_id = theSample.zIndex;
      }
    }
    theObject = {
      name: this.headerName,
      zIndex: max_id + 1,
      isParent: 1,
      parent_id: 0,
      status_code: '',
      organization_id: all_information.company_id?.toString(),
      user_id: all_information.user_id,
    };

    this.kanbanDesign
      .addKanbanDesign(theObject)
      .then((el) => {
        Message.success('Success');
        this.getSwimLanesData();
      })
      .catch((er) => {
        //('Error: ');
        if (er.response) {
          Message.error(
            er.response.data +
              '\n' +
              er.response.status +
              '\n' +
              er.response.headers
          );
        } else if (er.request) {
          Message.error(er.request);
        } else {
          Message.error('Error: ' + er.message);
        }
        Message.error(er.config);
      });
  }
  componentDidMount() {
    this.getSwimLanesData();
  }
  getSwimLanesData() {
    this.kanbanDesign
      .getKanbanDesign()
      .then((el) => {
        this.setState({
          swimLineData: el.data,
          showMenu: false,
          hideDialog: false,
          hideEditDialog: false,
        });
      })

      .catch((er) => {
        if (er.response) {
          Message.error(
            er.response.data +
              '\n' +
              er.response.status +
              '\n' +
              er.response.headers
          );
        } else if (er.request) {
          Message.error(er.request);
        } else {
          Message.error('Error: ' + er.message);
        }
        Message.error(er.config);
      });
  }
  actionComplete(args: any) {
    //(args);
  }
  onClickTab = (e: any, args: any) => {
    this.current_object = [];
    this.current_object.push(e);
    this.setState({
      hideDialog: true,
      xPos: args.clientX,
      yPos: args.clientY,
      isParent: e.isParent,
    });
  };
  onClickTabDeleteItem(args: any) {
    this.kanbanDesign
      .deleteKanbanDesign({
        id: args.id,
      })
      .then((el) => {
        Message.success('Success');
        this.getSwimLanesData();
      })
      .catch((er) => {
        if (er.response) {
          Message.error(
            er.response.data +
              '\n' +
              er.response.status +
              '\n' +
              er.response.headers
          );
        } else if (er.request) {
          Message.error(er.request);
        } else {
          Message.error('Error: ' + er.message);
        }
        Message.error(er.config);
      });
  }
  swimLineContent = (args: any) => {
    return (
      <div>
        <span style={{ marginRight: 5 }}>{args.name}</span>
        <RiMenu5Fill onClick={this.onClickTab.bind(this, args)} />
        <AiOutlineClose onClick={this.onClickTabDeleteItem.bind(this, args)} />
      </div>
    );
  };
  contentTemplateEachTab(comingData: any) {
    return (
      <div style={{ padding: 10 }}>
        <div className='row'>
          <div className='col-md-2'>
            <span style={{ marginRight: 10 }}>Status Code</span>
          </div>
          <div className='col-md-2'>
            <TextBoxComponent
              value={comingData.status_code}
              onChange={(args: any) => {
                comingData.status_code = args.value;
              }}
            />
          </div>
        </div>
        <div className='row' style={{ marginTop: 10 }}>
          <div className='col-md-2'>
            <span style={{ marginRight: 10 }}>Column Name</span>
          </div>
          <div className='col-md-2'>
            <TextBoxComponent
              value={comingData.name}
              onChange={(args: any) => {
                comingData.name = args.value;
              }}
            />
          </div>
        </div>
        <div className='row' style={{ marginTop: 10 }}>
          <div className='col-md-2'></div>
          <div className='col-md-3'>
            <ButtonComponent
              onClick={() => {
                var theMatch = this.state.swimLineData.findIndex((elIn) => {
                  return (
                    elIn.status_code === comingData.status_code &&
                    elIn.id !== comingData.id
                  );
                });
                var splitted_status = comingData.status_code.split(',');
                var isMatch: boolean = false;
                splitted_status.map((elSS: any) => {
                  this.state.swimLineData.map((elSD) => {
                    if (elSD.isParent === false && elSD.id != comingData.id) {
                      if (
                        elSD?.status_code
                          .toLowerCase()
                          .includes(elSS.trim().toLowerCase())
                      ) {
                        Message.error(`Case ${elSS} using by another fields`);
                        isMatch = true;
                        return;
                      }
                    }
                  });
                });
                if (isMatch) {
                  return;
                }
                if (theMatch !== -1) {
                  Message.error('All key must be uniq');
                  return;
                }
                comingData.isParent = 0;
                comingData.isStatusOp = true;
                //(comingData);

                this.kanbanDesign
                  .editKanbanDesign(comingData)
                  .then((el) => {
                    Message.success('Success');
                    this.getSwimLanesData();
                  })
                  .catch((er) => {
                    if (er.response) {
                      Message.error(er.response.data);
                      Message.error(er.response.status);
                      Message.error(er.response.headers);
                    } else if (er.request) {
                      Message.error(er.request);
                    } else {
                      Message.error('Error: ' + er.message);
                    }
                    Message.error(er.config);
                  });
              }}
            >
              Save
            </ButtonComponent>
          </div>
        </div>
      </div>
    );
  }
  createColumn(args: any) {
    var initialColName = 'col1';
    var isEnaught = true;
    var count = 1;
    var dedect_status = '';
    for (var i = 97; i < 123; i++) {
      var isExist = this.state.swimLineData.findIndex((ell) => {
        return ell.status_code?.toLowerCase() === String.fromCharCode(i);
      });
      if (isExist === -1) {
        dedect_status = String.fromCharCode(i).toUpperCase();
        break;
      }
    }
    while (isEnaught) {
      var isExist = this.state.swimLineData.findIndex((ell) => {
        return ell.name.toLowerCase() === `col${count}`;
      });
      if (isExist === -1) {
        initialColName = `col${count}`;
        break;
      }
      count++;
    }
    var max_id = 0;
    for (var i = 0; i < this.state.swimLineData.length; i++) {
      var theSample = this.state.swimLineData[i];
      if (max_id < theSample.zIndex) {
        max_id = theSample.zIndex;
      }
    }
    //(args);
    var theObject = {};
    if (this.current_object[0].parent_id !== null) {
      theObject = {
        name: initialColName,
        isParent: 0,
        parent_id: this.current_object[0].parent_id,
        status_code: dedect_status,
        zIndex: max_id + 1,
        organization_id: all_information.company_id?.toString(),
        user_id: all_information.user_id,
      };
    } else {
      theObject = {
        name: initialColName,
        isParent: 0,
        parent_id: -1,
        status_code: dedect_status,
        zIndex: max_id + 1,
        organization_id: all_information.company_id?.toString(),
        user_id: all_information.user_id,
      };
    }
    this.kanbanDesign
      .addKanbanDesign(theObject)
      .then((el) => {
        Message.success('Success');
        this.getSwimLanesData();
      })
      .catch((er) => {
        if (er.response) {
          Message.error(
            er.response.data +
              '\n' +
              er.response.status +
              '\n' +
              er.response.headers
          );
        } else if (er.request) {
          Message.error(er.request);
        } else {
          Message.error('Error: ' + er.message);
        }
        Message.error(er.config);
      });
  }
  generateChild(args: any, index: any, parentId: any) {
    var id = `SwimlanesTabsChild${index}`;
    var theFilteredData: Array<any> = [];
    theFilteredData = args.filter((el: any) => {
      return el.parent_id === parentId;
    });
    var data = args.filter((el: any) => {
      return el.id === parentId;
    });
    return (
      <div>
        {theFilteredData.length ? (
          <TabComponent id={id} allowDragAndDrop>
            <TabItemsDirective>
              {theFilteredData.map((el: any) => {
                // if (el.parent_id === parentId) {
                return (
                  <TabItemDirective
                    headerTemplate={this.swimLineContent.bind(this, el)}
                    content={this.contentTemplateEachTab.bind(this, el)}
                    key={Math.random() + 'generate-child'}
                  />
                );
              })}
            </TabItemsDirective>
          </TabComponent>
        ) : (
          <div
            style={{
              padding: 20,
            }}
          >
            <span style={{ marginRight: 5 }}>Add New Column</span>
            <RiMenu5Fill
              onClick={this.onClickTab.bind(this, {
                isParent: false,
                parent_id: data[0].id,
              })}
            />
          </div>
        )}
      </div>
    );
  }
  render() {
    return (
      <div className='swimline-content'>
        <span
          style={{
            fontSize: '14px',
            fontWeight: 'bold',
          }}
        >
          Swimlanes Settings
        </span>

        {this.state.swimLineData.length > 0 ? (
          <TabComponent id='SwimlanesTabs' allowDragAndDrop>
            <TabItemsDirective>
              {this.state.swimLineData.map((el: any, index: number) => {
                if (
                  el.isParent &&
                  (el.parent_id === 0 || el.parent_id === null)
                ) {
                  return (
                    <TabItemDirective
                      content={this.generateChild.bind(
                        this,
                        this.state.swimLineData,
                        index,
                        el.id
                      )}
                      key={index}
                      headerTemplate={this.swimLineContent.bind(this, el)}
                    />
                  );
                } else if (
                  el.isParent === false &&
                  (el.parent_id === 0 || el.parent_id === null)
                ) {
                  return (
                    <TabItemDirective
                      content={this.contentTemplateEachTab.bind(this, el)}
                      headerTemplate={this.swimLineContent.bind(this, el)}
                      key={index}
                    />
                  );
                }
              })}
            </TabItemsDirective>
          </TabComponent>
        ) : null}
        <table
          className='table'
          style={{
            backgroundColor: 'transparent',
            color: 'red',
          }}
        >
          <thead>
            <tr>
              <th scope='col'>Status Code</th>
              <th scope='col'>Mapped Case</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Q</td>
              <td>FORECAST</td>
            </tr>
            <tr>
              <td>S</td>
              <td>PLANNED</td>
            </tr>
            <tr>
              <td>I</td>
              <td>IN PROGRESS</td>
            </tr>
            <tr>
              <td>H</td>
              <td>ON HOLD</td>
            </tr>
            <tr>
              <td>C</td>
              <td>COMPLETE</td>
            </tr>
            <tr>
              <td>L</td>
              <td>CANCELED</td>
            </tr>
          </tbody>
        </table>
        {this.state.hideDialog ? (
          <DialogComponent
            isModal={true}
            id='defaultDialogDelete'
            visible={this.state.hideDialog}
            width={200}
            height={'auto'}
            position={{ X: this.state.xPos, Y: this.state.yPos }}
            open={() => {
              this.setState({ hideDialog: true });
            }}
            close={() => {
              this.setState({ hideDialog: false });
            }}
            overlayClick={() => {
              this.setState({ hideDialog: false });
            }}
            content={() => {
              return (
                <div className='container'>
                  <div
                    style={{
                      justifyContent: 'space-between',
                      alignItems: 'flex-start',
                      flexDirection: 'column',
                      display: 'flex',
                    }}
                  >
                    <button
                      style={{
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'row',
                        display: 'flex',
                        padding: 10,
                        backgroundColor: 'transparent',
                        border: 'none',
                      }}
                      onClick={this.createColumn.bind(this)}
                    >
                      <BiColumns style={{ marginRight: 10 }} />{' '}
                      <span>Add Column</span>
                    </button>
                    {this.state.isParent ? (
                      <button
                        style={{
                          justifyContent: 'center',
                          alignItems: 'center',
                          flexDirection: 'row',
                          display: 'flex',
                          padding: 10,
                          backgroundColor: 'transparent',
                          border: 'none',
                        }}
                        onClick={() => {
                          this.setState({
                            hideEditDialog: true,
                            showMenu: false,
                          });
                        }}
                      >
                        <BsColumns style={{ marginRight: 10 }} />
                        <span>Add Header</span>
                      </button>
                    ) : null}
                  </div>
                </div>
              );
            }}
          ></DialogComponent>
        ) : null}
        <div>
          <DialogComponent
            animationSettings={{ delay: 1, duration: 500, effect: 'FadeZoom' }}
            visible={this.state.hideEditDialog}
            header='Edit Element Alias'
            close={() => {
              this.setState({ hideEditDialog: false });
            }}
            open={() => {
              this.setState({ hideEditDialog: true });
            }}
            buttons={this.buttonForEdit}
            width={'330px'}
            isModal
            showCloseIcon
          >
            <div className='flex-elementAlias'>
              <div className='col-md-3'>
                <label className='flex-label'>Header Name</label>
              </div>
              <div className='col-md-9'>
                <TextBoxComponent
                  id='swimlanesHeaderName'
                  placeholder='Name'
                  floatLabelType='Auto'
                  value={this.headerName}
                  onChange={(el: any) => {
                    this.headerName = el.value;
                  }}
                />
              </div>
            </div>
          </DialogComponent>
        </div>
      </div>
    );
  }
}
